import { Record } from 'immutable';
import { AREA_TEXTS, METHOD_TEXTS, RECORD_STATUS_TEXTS } from '../consts';

export type ApiRecordUser = {
  name: string;
  user_no: number;
}

const RecordUserBase = Record({
  name: "",
  userNo: 0,
});

class RecordUser extends RecordUserBase {
  constructor(apiRecordUser?: ApiRecordUser) {
    super({
      name: apiRecordUser?.name,
      userNo: apiRecordUser?.user_no,
    })
  }
}

export type ApiDonorRecord = {
  id: number;
  donor: ApiRecordUser;
  donee: ApiRecordUser;
  donated_at: string;
  area: string;
  meth: string;
  status: string;
};

const DonorRecordBase = Record({
  id: 0,
  donor: new RecordUser(),
  donee: new RecordUser(),
  donatedAt: "",
  area: "",
  meth: "",
  status: ""
});

export class DonorRecord extends DonorRecordBase {
  constructor(apiDonorRecord?: ApiDonorRecord) {
    super({
      id: apiDonorRecord?.id,
      donor: new RecordUser(apiDonorRecord?.donor),
      donee: new RecordUser(apiDonorRecord?.donee),
      donatedAt: apiDonorRecord?.donated_at,
      area: apiDonorRecord?.area,
      meth: apiDonorRecord?.meth,
      status: apiDonorRecord?.status,
    })
  }

  readonly areaText: string = AREA_TEXTS[this.area];

  readonly methodText: string = METHOD_TEXTS[this.meth];

  readonly statusText: string = RECORD_STATUS_TEXTS[this.status];
}
